export const STATUS_OPTIONS = [
  { value: "contacted", label: "Contacted" },
  { value: "commercials_awaited", label: "Commercials Awaited" },
  { value: "negotiating", label: "Negotiating" },
  { value: "confirmed", label: "Confirmed" },
  { value: "cancelled", label: "Cancelled" },
  { value: "content_in_progress", label: "Content In Progress" },
  { value: "content_shared", label: "Content Shared" },
  { value: "content_approved", label: "Content Approved" },
  { value: "content_rejected", label: "Content Rejected" },
  { value: "payment_in_pipeline", label: "Payment in Pipeline" },
  { value: "completed", label: "Completed" },
] as const;
